import { Action } from './transaction-helper-action.interface';
import { ɵRuntimeError } from '@angular/core';

export class TransactionHelperActionDefault implements Action<void> {
    public execute(): void {
        const runtimeError: ɵRuntimeError = new ɵRuntimeError(
            303,
            'Ups, ocurrió un error, pero no te preocupes. Si el problema persiste, contacta con soporte a través del chat de la web.'
        );

        throw runtimeError;
    }
}
